import { Component, Inject, Input, OnInit } from '@angular/core';
import { helpUrlsLookup } from 'go-modules/help-urls/help-urls.constant';
import { activityToken } from 'go-modules/models/activity/activity.factory';
import { NgxActivityService } from '@go-modules/services/activity/activity.service';
import { ActivityReport, OldSessionReport } from '@go-modules/interfaces/activity-summary-report';
import { NgxSessionService } from '@go-modules/services/session/session.service';
import { BehaviorSubject } from 'rxjs';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MarkerDisplayModule } from '@go-modules/components/marker-display/marker-display.module';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';
import { GoModulesModule } from '@go-modules/go-modules.module';

export enum LoadingState {
	LOADING,
	LOADED,
	ERROR
}

@Component({
	selector: 'activity-report-old',
	templateUrl: './activity-report-old.component.html',
	styleUrls: ['./activity-report-old.component.scss'],
	imports: [
		NgxZeroStateModule,
		NgClass,
		MarkerDisplayModule,
		DatePipe,
		FormatTimeModule,
		AsyncPipe,
		TranslateModule,
		GoModulesModule
	]
})
export class ActivityReportOldComponent implements OnInit {
	@Input() public activityId;
	@Input() public groupId;

	public helpUrls = helpUrlsLookup;
	public loadedState$ = new BehaviorSubject<LoadingState>(LoadingState.LOADING);
	public LoadingState = LoadingState;
	public summarizedReport;
	public userReports: {
		[key: string]: OldSessionReport[]|null
	} = {};

	constructor (
		private activityService: NgxActivityService,
		private sessionService: NgxSessionService,
		@Inject(activityToken) private ActivityModel
	) {}

	public ngOnInit (): void {
		this.activityService.getSummaryReport(this.activityId, this.groupId).subscribe({
			next: (data: ActivityReport[]) => {
				data.forEach((item) => {
					item.fullname = `${item.first_name} ${item.last_name}`;
					item.expanded = false;
				});

				// Alphabetize
				const summarizedReport = data.sort((userA, userB) =>
					userA.last_name.toLowerCase().localeCompare(userB.last_name.toLowerCase())
				);

				this.summarizedReport = summarizedReport;
				this.loadedState$.next(LoadingState.LOADED);
			},
			error: () => {
				this.loadedState$.next(LoadingState.ERROR);
			}
		});
	}

	public getUserReport (userId: number) {
		if (!this.userReports[userId]) {
			this.sessionService.getSummaryReport(
				this.groupId, userId, this.activityId
			).subscribe((data: OldSessionReport[]) => {
				data.forEach((session) => {
					session.activity = this.ActivityModel.model(session.activity);
				});
				this.userReports[userId] = data.length ? data : null;
			});
		}
	}

	public toggleUser (user) {
		user.expanded = !user.expanded;
		this.getUserReport(user.user_id);
	}
}
